module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/apple-store-hover-88bba5792c65c901dc78f847b1df8aa9.png";